import { render, staticRenderFns } from "./TaxSales.vue?vue&type=template&id=53309f5e&"
import script from "./TaxSales.vue?vue&type=script&lang=js&"
export * from "./TaxSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports